import React from "react";
import logo from "../assets/images/gurujibook1.png";
import "./Content.css";
import book2 from "../assets/images/gurujibook.png";



export const Content = () => {
  return (
    <div className=" bg-[#F1F1F6]">
    <div className="container mx-auto my-4">
      <h4 className="py-5">Latest From Guruji Publishing House Blog</h4>
      <div className="grid grid-cols-3 gap-4 mb-5" id="slide">
        <img className="" src={book2}></img>
        <img className="" src={book2}></img>
        <img className="" src={book2}></img>
      </div>
      </div>
      <hr className="py-9"/>
      <h4 className="py-9">Our Top Books For 2025</h4>
      <div className="grid grid-cols-4 gap-4" id="slide">
      <img className="" src={logo}></img>
        <img className="" src={logo}></img>
        <img className="" src={logo}></img>
        <img className="" src={logo}></img>
    </div>
    </div>
  );
};
